var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n    .menu-icon rect { fill: #fff; }\n  "),React.createElement("g",{"className":"top","key":1},React.createElement("rect",{"x":"2","y":"7","width":"32","height":"2"})),React.createElement("g",{"className":"middle","key":2},React.createElement("rect",{"x":"2","y":"17","width":"32","height":"2"})),React.createElement("g",{"className":"bottom","key":3},React.createElement("rect",{"x":"2","y":"27","width":"32","height":"2"}))]);
}

MenuIcon.defaultProps = {"className":"menu-icon","width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
